import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { RouteFormComponent } from '../route-form/route-form.component';
import { RouteService } from '../../../Model/Route/route.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-route',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, LoaderComponent],
  templateUrl: './route.component.html',
  styleUrl: './route.component.scss'
})
export class RouteComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  isDisabled: boolean = false;
  private modalService = inject(NgbModal);
  dtTrigger: Subject<any> = new Subject<any>();
  TableDatas: any[] = []
  public User: any = null
  filter = {
    SelectType: 1,
    ESS_RouteMasterid: 0
  }
  dtoptions: DataTables.Settings = {};
  constructor(private route: RouteService,
    protected common: CommonService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  
  ngOnInit(): void {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  add(id: number, Code: string, Name: string, ClusterId: any, SiteOwnerID: any) {
    const modalRef = this.modalService.open(RouteFormComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.Code = Code;
    modalRef.componentInstance.Name = Name;
    modalRef.componentInstance.ClusterId = ClusterId;
    modalRef.componentInstance.SiteOwnerId = SiteOwnerID;
    modalRef.result.then((result: any) => {
      if (result) {
        this.getData();
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  getData() {
    this.isDisabled = true;
    this.route.ESS_RouteMaster(this.filter).subscribe({
      next: (response) => {
        if (response) {
          this.TableDatas = Object.values(response.Table);
          this.isDisabled = false;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
